import store from 'storejs';
import block from "bem-css-modules";
import {useController} from "react-hook-form";
import RadioGroup from "./../RadioGroup";
import {RECURRING} from "../../Constants/PaymentTypes";

import s from './RecurringPayment.module.scss';

const b = block(s);

const RecurringPayment = ({control, name}) => {
    const {
        field: {onChange, onBlur, value},
        fieldState: {error},
    } = useController({
        name,
        control,
        rules: {required: true},
    })

    const recurring = store(RECURRING);

    return <div className={b()}>
        <RadioGroup onBlur={onBlur} onChange={onChange} value={value} items={recurring} error={error} name={name}/>
        <span className='error'>{error?.message}</span>
    </div>
}

export default RecurringPayment;
